import { create } from 'zustand';

import { type RebookingFilterForm } from './types';

interface RebookingStore {
    page: number;
    filters: RebookingFilterForm | null;
    weeksFree: number;

    setFilters(filters: RebookingFilterForm): void;
    setPage(nextPage: number): void;
    setWeeksFree(weeksFree: number): void;
}

interface ContactModalStore {
    open: boolean;

    openModal(): void;
    closeModal(): void;
}

export const useRebookingStore = create<RebookingStore>((set) => ({
    page: 1,
    filters: null,
    weeksFree: 0,

    setFilters(filters) {
        set({ filters, page: 1 });
    },

    setPage(page) {
        set({ page });
    },

    setWeeksFree(weeksFree: number) {
        set({ weeksFree });
    },
}));

export const useContactModalStore = create<ContactModalStore>((set) => ({
    open: false,

    openModal() {
        set((state) => {
            if (state.open) return state;
            return { open: true };
        });
    },

    closeModal() {
        set((state) => {
            if (!state.open) return state;
            return { open: false };
        });
    },
}));

export const useKeepReleaseModalStore = create<ContactModalStore>((set) => ({
    open: false,

    openModal() {
        set((state) => {
            if (state.open) return state;
            return { open: true };
        });
    },

    closeModal() {
        set((state) => {
            if (!state.open) return state;
            return { open: false };
        });
    },
}));
